import type { Program } from 'models';
import { Trans } from 'react-i18next';
import { Text } from 'ui/typography';
import { ContactUs } from '../../../../contact-us';

type P = {
  isContactUsVisible: boolean;
  isFree: boolean;
  missingToPay: number;
  onContactUsSuccess: (programId: string) => Promise<void>;
  paidBySponsors: number;
  program: Program;
  totalPrice: number;
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramPrice = ({
  isContactUsVisible,
  isFree,
  missingToPay,
  onContactUsSuccess,
  paidBySponsors,
  program,
  totalPrice,
}: P) => {
  if (isFree) {
    return (
      <Text className="program-topbar__price__free">
        <Trans>Free program</Trans>
      </Text>
    );
  }

  if (isContactUsVisible) {
    return <ContactUs onSuccess={onContactUsSuccess} programData={program} />;
  }

  if (paidBySponsors > 0) {
    return (
      <div className="program-topbar__price__price-wrapper">
        <Text className="program-topbar__price__discount">${totalPrice.toFixed(2)}</Text>
        <Text className="program-topbar__price__value">${missingToPay.toFixed(2)}</Text>
      </div>
    );
  }

  if (totalPrice) {
    return <Text className="program-topbar__price__price-wrapper">${totalPrice.toFixed(2)}</Text>;
  }

  return null;
};

export default ProgramPrice;
